export default () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
